import Sentry from "@similarweb/sentry-logger";

import type {
    ISupportedLanguageByGoogle,
    ISupportedLanguagesAndLocale,
    ISupportedLocationByGoogle,
} from "app/components/campaigns/campaigns-wizard/CampaignsWizardConsts";
import { getAPIPrefixForRT } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsInfraUtils";
import { DefaultFetchService } from "app/services/fetchService";

export const fetchService = DefaultFetchService.getInstance();

export const fetchLocations = async (isDemoCampaign: boolean): Promise<ISupportedLocationByGoogle[]> => {
    const geoLocationsURL = (isDemo: boolean) => `${getAPIPrefixForRT(isDemo)}/settings/geolocations`;
    try {
        return fetchService.get<ISupportedLocationByGoogle[]>(geoLocationsURL(isDemoCampaign), {});
    } catch (error) {
        Sentry.error(`Error fetching Geo Locations from server -`, error as Error);
        return [];
    }
};

const fetchLanguages = async (isDemoCampaign: boolean): Promise<ISupportedLanguageByGoogle> => {
    return fetchService.get<ISupportedLanguageByGoogle>(`${getAPIPrefixForRT(isDemoCampaign)}/settings/languages`, {});
};
export const getLanguagesList = async (isDemoCampaign: boolean): Promise<ISupportedLanguagesAndLocale[]> => {
    try {
        const languages: ISupportedLanguageByGoogle = await fetchLanguages(isDemoCampaign);
        if (languages.locale) {
            return Object.entries(languages.locale).map(([locale, value]) => {
                return {
                    description: value.description,
                    locale: locale,
                };
            });
        } else {
            return [];
        }
    } catch (error) {
        Sentry.error(`Error fetching Geo Locations from server -`, error as Error);
        return [{ description: "English", locale: "en-us" }];
    }
};
